export default __webpack_public_path__ + "static/media/shop_5.30969260.png";